import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import ReactEcharts from "echarts-for-react";
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import { getSurveyDetail, getDefaultReport, getSurveyResult, getSurveySectionData } from '../../store/actions/surveyFormAction';
 import { GetToken } from "../../store/actions/tokenAction";
 import { checkPublish, getLeadFormData, submitLeadFormData } from "../../store/actions/leadFormAction";
 import CustomInput from "../../submodules/landingPage/components/CustomInput"; 
 import { isLeadFormFieldHidden } from "../../utils/leadFormFieldUtils";
 import { useFormik } from "formik";
 import * as Yup from "yup";
 import { toast } from "react-toastify";
import Axios from "axios";
// import Report from './report/Report';
import theme__ from '../../../common/ThemeSettings';
import { donwloadPdfFile } from '../../store/actions/donwloadPdfAction';
import Svg from "../../../common/Svg";
import logoImage2 from '../../../../assets/images/tata-logo.png';
import CryptoJS from 'crypto-js';
import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth, signInWithCustomToken } from "firebase/auth";


export default function Thankyou() {
    //States
    const [isMobile, setIsMobile] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const { survey_id, ss_id } = useParams();
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const result = useSelector((state) => state?.survey?.surveyData?.surveyResult)
    const surveySections = useSelector((state) => state?.survey?.surveyData?.surveySections)
    const surveyDetail = useSelector((state) => state?.survey?.surveyData?.surveyDetail)
    const { defaultReport } = useSelector((state) => state?.survey?.surveyData)
     const { leadFormData } = useSelector((state) => state?.survey?.leadFormData || {});
    const { publishData }  = useSelector((state) => state?.survey?.publishData || {});
    const [theme, setTheme] = useState(-1);
    const [themeSet, setThemeSet] = useState([]);
    const [logoImage, setLogoImage] = useState('');
    const [isGraph, setIsGraph] = useState('');
    const [isAiReadiness, setIsAiReadiness] = useState('');
    const [graphType, setGraphType] = useState('');
    const [percentage, setPercentage] = useState(0);
    const [description, setDescription] = React.useState("");
    const [heading, setHeading] = useState("");
    const [submitTitle, setSubmitTitle] = useState("Submit");
    const [submitPosition, setSubmitPosition] = useState("start");
    const [TandC, setTandC] = useState("");
    const [TandCOption, setTandCOption] = useState({});
    const [TandCSecond, setTandCSecond] = useState("");
    const [TandCSecondOption, setTandCSecondOption] = useState({});
    const [TandCThird, setTandCThird] = useState("");
    const [TandCThirdOption, setTandCThirdOption] = useState({});
    const [emailVerify, setEmailVerify] = useState(false);
    const [emailValidationTiming, setEmailValidationTiming] = useState("");
    const [flagFormStep, setFlagFormStep] = useState(1); // 1=form, 2=otp
    const [leadId, setLeadId] = useState("");
    const [otp, setOtp] = useState("");
    const [otpError, setotpError] = useState(false);
    const [checkotp, setcheckotp] = useState("");
    const [subLoading, setSubLoading] = useState(false);
    const [showLeadFormModal, setShowLeadFormModal] = useState(false);
    const [displayForm, setDisplayForm] = useState('');
    const [hasLeadInfo, setHasLeadInfo] = useState(false);
    const [isResolvingPendingAction, setIsResolvingPendingAction] = useState(false);
    const [autoActionUi, setAutoActionUi] = useState(null); // 'view' | 'download' | null
    const PENDING_AUTH_ACTION_KEY = "thankyou_pending_auth_action";
    const [afterLeadAction, setAfterLeadAction] = useState(null); 
    const autoActionHandledRef = useRef(false);

  const formLoadedRef = useRef(false);
  const hubspotAutoRunRef = useRef(false);
  const utmAttachedRef = useRef(false);

  const setPendingAuthAction = (intent) => {
    try {
      localStorage.setItem(
        PENDING_AUTH_ACTION_KEY,
        JSON.stringify({
          intent,
          survey_id,
          ss_id,
          createdAt: Date.now()
        })
      );
    } catch (e) {
      // no-op
    }
  };

  const getPendingAuthAction = () => {
    try {
      const raw = localStorage.getItem(PENDING_AUTH_ACTION_KEY);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      const isSameSurvey = parsed?.survey_id === survey_id;
      const isSameSession = !parsed?.ss_id || parsed?.ss_id === ss_id;
      const isValidIntent = parsed?.intent === "view" || parsed?.intent === "download";
      // Expire pending actions older than 5 minutes (covers stale/abandoned login attempts)
      const isRecent = parsed?.createdAt && (Date.now() - parsed.createdAt < 5 * 60 * 1000);
      if (!isSameSurvey || !isSameSession || !isValidIntent || !isRecent) {
        // Clean up expired/invalid entries
        localStorage.removeItem(PENDING_AUTH_ACTION_KEY);
        return null;
      }
      return parsed.intent;
    } catch (e) {
      return null;
    }
  };

  const clearPendingAuthAction = () => {
    try {
      localStorage.removeItem(PENDING_AUTH_ACTION_KEY);
    } catch (e) {
      // no-op
    }
  };
  const pendingIntent = afterLeadAction;
  const isAutoActionUi = autoActionUi === "view" || autoActionUi === "download";
  const isPendingAuthResume =
    (displayForm || "").trim().toLowerCase() === "before report" &&
    !hasLeadInfo &&
    (pendingIntent === "view" || pendingIntent === "download");
  
  // Full-screen overlay: show when auto-action is executing
  const showProcessingOverlay = isAutoActionUi || isPendingAuthResume;
  const actionLock = showProcessingOverlay || isResolvingPendingAction;
  const processingIntent = autoActionUi || pendingIntent;
  const processingTitle = processingIntent === "download"
    ? "Preparing Your Report Download"
    : "Opening Your Report";
  const processingMessage = processingIntent === "download"
    ? "Verifying sign-in and preparing your report download..."
    : "Verifying sign-in and opening your report...";
  const viewReportLabel = isResolvingPendingAction
    ? "Checking Sign-in..."
    : ((displayForm || "").trim().toLowerCase() === "before report"
      ? (hasLeadInfo ? "View Report" : "Sign Up to View Report")
      : "View Report");
  const downloadReportLabel = isResolvingPendingAction
    ? "Checking Sign-in..."
    : ((displayForm || "").trim().toLowerCase() === "before report" && !hasLeadInfo
      ? "Sign Up to Download Report"
      : "Download report");
  
  // ---------------------------------------------
  // Firebase config from env (must restart dev server after .env change)
  const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
  };

  // TEMP flag: will be replaced by backend-controlled value later
const USE_HUBSPOT_SIGNUP = 1;


   // Small helpers to DRY the "open form vs HubSpot login" decision
 const showLeadForm = () => {
   setShowLeadFormModal(true);
   openFormIfNeeded();
   const el = document.getElementById("leadFormModal");
   if (el && window.bootstrap) {
     window.bootstrap.Modal.getOrCreateInstance(el).show();
   } else if (el && window.$) {
     window.$(el).modal("show");
   }
 };

 const startSignup = (intent /* 'view' | 'download' */) => {
   setPendingAuthAction(intent);
   if (USE_HUBSPOT_SIGNUP === 1) {
     // Tata Comm HubSpot login → comes back with ?customToken or ?e=
     // Don't set afterLeadAction state here — the page redirects away instantly
     // and setting state before redirect causes a brief spinner flash.
     handleHubspotAuth();
   } else {
     // Normal flow → open your existing lead form modal
     setAfterLeadAction(intent);
     showLeadForm();
   }
 };
  // LocalStorage helpers for user_config
  const readUserConfig = () => {
    try {
      const raw = localStorage.getItem('user_config');
      return raw ? JSON.parse(raw) : {};
    } catch (e) {
      return {};
    }
  };

  const saveUserConfig = (obj) => {
    try {
      localStorage.setItem('user_config', JSON.stringify(obj ?? {}));
    } catch (e) {
      // no-op
    }
  };

  const attachUtmToUrlFromDb = useCallback(async () => {
    try {
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/frnt/get-link-info`,
        { ss_id }
      );
      const linkInfo = response?.data?.data || {};
      const url = new URL(window.location.href);
      const keys = ["utm_source", "utm_medium", "utm_campaign", "utm_content"];
      let updated = false;
      keys.forEach((key) => {
        if (!url.searchParams.get(key) && linkInfo[key]) {
          url.searchParams.set(key, linkInfo[key]);
          updated = true;
        }
      });
      if (updated) {
        window.history.replaceState({}, "", url.toString());
      }
    } catch (e) {
      // no-op: fall back to existing URL if link info is unavailable
    }
  }, [ss_id]);

  const getCustomTokenFromURL = () => {
    const url = new URL(window.location.href);
    const token = url.searchParams.get('customToken');
    if (token) {
      url.searchParams.delete('customToken');
      window.history.replaceState({}, '', url.toString());
    }
    return token;
  };

const buildLoginUrl = (ehValue) => {
  const loginUrl = new URL('https://tatacomms.letschbang.com/login');
  loginUrl.searchParams.set('id', ehValue);
  const params = new URLSearchParams(window.location.search);
  ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'lid'].forEach((key) => {
    const value = params.get(key);
    if (value) {
      loginUrl.searchParams.set(key, value);
    }
  });
  return loginUrl.toString();
};

  // Resolve pending action on return without flashing "Sign Up" buttons first.
  // We only show the full-screen overlay once login is confirmed via lead-info.
  useEffect(() => {
    let cancelled = false;
    const pending = getPendingAuthAction();
    if (!pending || !ss_id) return;

    setIsResolvingPendingAction(true);
    (async () => {
      // In iframe flows, lead info can take a few seconds to be reflected.
      // Poll briefly before deciding that login did not complete.
      for (let attempt = 0; attempt < 8; attempt++) {
        try {
          const hasInfo = await checkLeadInfo(ss_id);
          if (cancelled) return;
          if (hasInfo) {
            setAfterLeadAction(pending);
            setIsResolvingPendingAction(false);
            return;
          }
        } catch (e) {
          // keep retrying for transient response delays
        }
        await new Promise((resolve) => setTimeout(resolve, 1000));
      }
      if (!cancelled) {
        // No confirmed login after retries -> clear stale pending action.
        clearPendingAuthAction();
        setIsResolvingPendingAction(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [survey_id, ss_id]);

  useEffect(() => {
    const token = getCustomTokenFromURL();
    if (!token) return;

    // Guard: ensure apiKey present
    if (!firebaseConfig.apiKey) {
      console.error('Firebase config missing. Ensure REACT_APP_FIREBASE_* env vars and restart dev server.');
      return;
    }

    const app = getApps().length ? getApp() : initializeApp(firebaseConfig);
    const auth = getAuth(app);

    signInWithCustomToken(auth, token)
      .then((cred) => {
        const email = cred?.user?.email || '';
        const uid = cred?.user?.uid || '';
        const current = readUserConfig();
        saveUserConfig({ ...current, email, uid });
        if (email) runHubspotAutoSignup(email, getPendingAuthAction() || 'view');
      })
      .catch((err) => {
        console.error('Firebase custom token sign-in failed:', err);
      });
  }, []);

  // If email already exists in localStorage.user_config, call HubSpot once on mount
  useEffect(() => {
    try {
      const cfgRaw = localStorage.getItem('user_config');
      const cfg = cfgRaw ? JSON.parse(cfgRaw) : {};
      const email = cfg?.email;
      if (!email) return;
      runHubspotAutoSignup(email, getPendingAuthAction() || 'view');
    } catch (e) {}
  }, []);

  function buildPrefillFromHubspot(hubProps = {}) {
    return {
      email: hubProps.email || '',
      firstName: hubProps.firstname || '',
      lastName: hubProps.lastname || '',
      company: hubProps.company || '',
      busPhone: (hubProps.phone || '').replace(/^(\+91[\s-]*)/, ''),
      state: hubProps.state || '',
      designation: hubProps.designation_ || hubProps.designation || '',
      country: hubProps.country || '',
      TANDC: 'on'
    };
  }

  async function runHubspotAutoSignup(email, intent = 'view') {
    try {
      const hubUser = await fetchHubspotUser(email);
      console.log('HubSpot contact properties:', hubUser);
      if (!hubUser) return;

      if (hubUser.hs_object_id) {
        localStorage.setItem('hs_object_id', hubUser.hs_object_id);
      }

    const shouldAuto = USE_HUBSPOT_SIGNUP === 1
      && ((displayForm || '').trim().toLowerCase() === 'before report')
      && !hasLeadInfo;
      if (!shouldAuto) {
        // Always silently submit HubSpot data even if we are not auto-running the modal flow
        const prefill = buildPrefillFromHubspot(hubUser);
        try {
          const merged = { ...formik.values, ...prefill };
          formik.setValues(merged);
          await silentSubmitLeadInfo(merged);
        } catch (e) {
          console.error('HubSpot silent submit failed:', e);
        }
        return;
      }

      if (hubspotAutoRunRef.current) return; // avoid duplicate submits
      hubspotAutoRunRef.current = true;

      const prefill = buildPrefillFromHubspot(hubUser);
      try {
        const merged = { ...formik.values, ...prefill };
        formik.setValues(merged);
        // Silently store HubSpot data without opening modal or navigating
        await silentSubmitLeadInfo(merged);
      } catch (e) {
        console.error('HubSpot auto-signup failed:', e);
        hubspotAutoRunRef.current = false;
      }
    } catch (e) {
      console.error('HubSpot auto-signup error:', e);
    }
  }

  const openFormIfNeeded = () => {
    if (formLoadedRef.current) return;
    formLoadedRef.current = true;
    dispatch(GetToken())
      .then(() => dispatch(checkPublish({ survey_id })))
      .then(() => {
        // only fetch if we don't already have it
        if (!leadFormData || leadFormData.length === 0) {
          return dispatch(getLeadFormData({ survey_id }, navigate));
        }
      });
  };
  //   if (formLoadedRef.current) return;
  //   formLoadedRef.current = true;
  //   dispatch(GetToken()).then(() => {
  //     dispatch(checkPublish({ survey_id })).then(() => {
  //       dispatch(getLeadFormData({ survey_id }, navigate));
  //     });
  //   });
  // };


// decode "&lt;p&gt; ... &nbsp;" -> real HTML
const decodeHTML = (str = "") => {
  const doc = new DOMParser().parseFromString(str, "text/html");
  return doc.documentElement.textContent || "";
};
const asHTML = (str) => ({ __html: decodeHTML(str) });

// HubSpot dynamic auth helpers (reuse LandingPage secret)
const HS_SECRET = "a3dcb4d229de6fde0db5686dee47145d2b34fdf032f7d7c3d3ff7e5cd7eb617a";

const encryptEmail = (email) =>
  CryptoJS.AES.encrypt(email, HS_SECRET).toString();

const decryptToken = (token) => {
  try {
    return CryptoJS.AES.decrypt(token, HS_SECRET).toString(CryptoJS.enc.Utf8);
  } catch {
    return "";
  }
};

const fetchHubspotUser = async (email) => {
  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/survey/hubspot-contact-by-email`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ user_email: email })
    });
    const json = await res.json();
    return json?.results?.[0]?.properties || null;
  } catch {
    return null;
  }
};

// Hoisted helper to silently submit lead info without opening modal or navigation
async function silentSubmitLeadInfo(formData) {
  try {
    await Axios.post(`${process.env.REACT_APP_API_URL}/frnt/update-lead-info`, { ss_id, su_lead_info: formData });
    const response = await Axios.post(`${process.env.REACT_APP_API_URL}/frnt/check-lead-info`, { ss_id });
    setHasLeadInfo(response?.data?.hasInfo === true);
  } catch (e) {
    console.error('Silent lead info submit failed:', e);
  }
}

    //Scrolling config
    var keys = { 37: 1, 38: 1, 39: 1, 40: 1 }

    function preventDefault(e) {
        e.preventDefault();
    }

    function preventDefaultForScrollKeys(e) {
        if (keys[e.keyCode]) {
            preventDefault(e);
            return false;
        }
    }

    // modern Chrome requires { passive: false } when adding event
    let supportsPassive = false;
    try {
        window.addEventListener("test", null, Object.defineProperty({}, 'passive', {
            get: function () { supportsPassive = true; }
        }))
    } catch (e) { }

    let wheelOpt = supportsPassive ? { passive: false } : false;
    let wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';

    const disableScroll = () => {
        window.addEventListener('DOMMouseScroll', preventDefault, false);
        window.addEventListener(wheelEvent, preventDefault, wheelOpt);
        window.addEventListener('touchmove', preventDefault, wheelOpt);
        window.addEventListener('keydown', preventDefaultForScrollKeys, false);
    }

    const enableScroll = () => {
        window.removeEventListener('DOMMouseScroll', preventDefault, false);
        window.removeEventListener(wheelEvent, preventDefault, wheelOpt);
        window.removeEventListener('touchmove', preventDefault, wheelOpt);
        window.removeEventListener('keydown', preventDefaultForScrollKeys, false);
    }

    //Download PDF
    const pdfRef = useRef(null)
    const printDocument = async () => {
        // Patch API for report download if survey_id matches
        if (survey_id === 'b6420220-5ba7-11ef-b484-6dfb5d512f67') {
            const hs_object_id = localStorage.getItem('hs_object_id');
            if (hs_object_id) {
                await fetch(`${process.env.REACT_APP_API_URL}/survey/patchAPI`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: `userId=${encodeURIComponent(hs_object_id)}&action=report_download&value=1`
                });
            }
        }
        setIsLoading(true)
        // Get the current hostname and protocol
        const currentHostname = window.location.host;
        const currentProtocol = window.location.protocol;
        const data = {
            // url: `http://localhost:3000/thank-you/${survey_id}/${ss_id}`,
            url: `${currentProtocol}//${currentHostname}/report/${survey_id}/${ss_id}/${defaultReport?.default_report}?ispdf=true`,
            // url: `https://www.google.com`,
            survey_id: survey_id,
            ss_id: ss_id,
        };
         await dispatch(donwloadPdfFile(data))
            .then(() => { 
                setIsLoading(false);
                setAutoActionUi(null); // Clear overlay after download completes
            })
            .catch((err) => { 
                setIsLoading(false);
                setAutoActionUi(null); // Clear overlay on error too
            })
          await dispatch(getSurveyResult({ survey_id, ss_id }));
    }

    const getPDF = async () => {
        const elems = pdfRef.current?.children[0]?.children

        const pdf = new jsPDF("landscape", "px", undefined, true)

        for (let i = 0; i < elems.length; i++) {
            const elementHeight = elems[i].offsetHeight
            const elementWidth = elems[i].offsetWidth
            pdf.addPage([elementWidth / 2, elementHeight / 2]);
        }

        const pages = []

        for (let i = 0; i < elems.length; i++) {
            let htmlData = elems[i]
            pages.push(html2canvas(htmlData, { scale: 3 }))
        }

        await Promise.all(pages).then((values) => {
            for (let i = 0; i < values.length; i++) {
                const elementHeight = elems[i].offsetHeight
                const elementWidth = elems[i].offsetWidth

                // console.log('elementHeight', elementHeight)
                // console.log('elementWidth', elementWidth)

                let imgSrc = values[i].toDataURL("image/jpeg")
                let imgageData = new Image()

                // const pdfWidth = pdf.internal.pageSize.getWidth();
                // const pdfHeight = pdf.internal.pageSize.getHeight();

                if (imgSrc.split(',')[1] === '') {
                    //Adding blank image if there is no data
                    imgSrc = 'data:image/png;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='

                }
                imgageData.src = imgSrc;
                imgageData.onload = () => {
                    pdf.setPage(i + 2)
                    pdf.addImage(imgageData, "JPEG", 0, 0, elementWidth / 2, elementHeight / 2, '', 'FAST')

                    if (i === elems.length - 1) {
                        pdf.deletePage(1)
                        setTimeout(() => {
                            pdf.save()
                        }, 0)
                    }
                }
            }
        });

    }

    // const getPDF = async () => {
    //     const elems = pdfRef.current?.children[0]?.children

    //     // console.log('elems', elems[17])
    //     // const pdf = new jsPDF("landscape", "px")
    //     const pdf = new jsPDF("landscape", "px", undefined, true)

    //     for (let i = 0; i < elems.length; i++) {
    //         let htmlData = elems[i]

    //         await html2canvas(htmlData, { scale: 3 })
    //             .then(async (canvas) => {
    //                 const elementHeight = elems[i].offsetHeight
    //                 const elementWidth = elems[i].offsetWidth

    //                 // console.log('elementHeight', elementHeight)
    //                 // console.log('elementWidth', elementWidth)

    //                 let imgSrc = canvas.toDataURL("image/png")
    //                 let imgageData = new Image()

    //                 // const pdfWidth = pdf.internal.pageSize.getWidth();
    //                 // const pdfHeight = pdf.internal.pageSize.getHeight();

    //                 if (imgSrc.split(',')[1] === '') {
    //                     //Adding blank image if there is no data
    //                     imgSrc = 'data:image/png;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
    //                 }

    //                 imgageData.src = imgSrc;
    //                 imgageData.onload = () => {
    //                     pdf.addPage([elementWidth / 2, elementHeight / 2]);
    //                     pdf.addImage(imgageData, "PNG", 0, 0, elementWidth / 2, elementHeight / 2)
    //                     // console.log('Page:', i + 1, imgSrc)

    //                     if (i === elems.length - 1) {
    //                         pdf.deletePage(1)
    //                         pdf.save()
    //                     }
    //                 }

    //             }).catch((error) => {
    //                 console.log('Add page error', error)
    //             })
    //     }
    // }

    const loadImageData = async () => {
        const elems = pdfRef.current?.children[0]?.children
        for (let i = 0; i < elems.length; i++) {
            let liveImages = elems[i].querySelectorAll('img')
            for (let j = 0; j < liveImages.length; j++) {
                const liveLink = liveImages[j].src
                const protocol = liveLink.split('://')[0]
                if (protocol === 'http' || protocol === 'https') {
                    await getBase64FromUrl(liveLink).then((data) => {
                        liveImages[j].src = data
                    }).catch((error) => {
                        console.log('Image fetching error', error)
                    })
                }
            }
        }

        var rawElems = pdfRef.current?.children[0]?.querySelectorAll('*')

        for (let i = 0; i < rawElems.length; i++) {
            let element = rawElems[i]
            const styles = window.getComputedStyle(element);

            const gackgroundImage = styles.getPropertyValue('background-image')
            if (gackgroundImage !== 'none') {
                const liveLink = gackgroundImage?.split('"')[1]
                const protocol = liveLink?.split('://')[0]

                if (protocol === 'http' || protocol === 'https') {
                    await getBase64FromUrl(liveLink).then((data) => {
                        element.style.backgroundImage = `url(${data})`
                    }).catch((error) => {
                        console.log('Image fetching error', error)
                    })
                }
            }
        }
    }

    // const getBase64Image = (img, callBack) => {
    //     img.setAttribute('crossorigin', 'anonymous');
    //     img.onload = () => {
    //         var canvas = document.createElement("canvas");
    //         canvas.width = img.width + 5;
    //         canvas.height = img.height + 5;
    //         var ctx = canvas.getContext("2d");
    //         ctx.drawImage(img, 0, 0);
    //         let dataURL = canvas.toDataURL("image/png");
    //         const src = `${img.src}`
    //         if (!src?.includes('data:image/png;base64'))
    //             callBack(dataURL)
    //     }
    // }

    const getBase64FromUrl = async (url) => {
        try {
            const data = await fetch(url, {
                method: 'get',
                mode: 'cors',
                cache: 'no-store',
                headers: {
                    'pragma': 'no-cache',
                    'cache-control': 'no-cache'
                }
            })
            const blob = await data.blob()

            return new Promise((resolve) => {
                const reader = new FileReader()
                reader.readAsDataURL(blob)
                reader.onloadend = () => {
                    let base64data = reader.result;
                    const rawData = base64data?.split('base64,')
                    base64data = 'data:image/png;base64,' + rawData[1]
                    resolve(base64data)
                }
            })

        } catch (err) {
            console.log('FETCH IMAGE ERR', err, '---', url)
        }
    }

    //Colors
    const sectionColors = ['#000', '#000', '#000', '#000', '#000', '#000']

    //Options and style
    const style = {
        height: isMobile ? '320px' : '420px',
        width: '100%',
        padding: isMobile ? '25px 5px 15px 5px' : '30px 20px 20px 20px',
        // add the chart-container class
        className: 'chart-container',
    }

    const styleGauge = {
        height: '400px',
        width: '100%',
        // add the chart-container class
        className: 'chart-container',
    }

    const option = useMemo(() => {
        //Intervals and max value
        const interval = Number(result?.graph_interval ?? 3)
        const intervalCount = Number(result?.graph_interval_count ?? 100)
        const maxValue = interval * intervalCount
        setPercentage(result?.percentage);

        //Functionalities
        const getIndicator = (name, colorIndex) => {
            return { name: name, max: maxValue, color: '#555' }
        }

        //Get sections and indicators
        let indicators = []
        let values = []
        const sectionWithScore = result?.section_maturity_score
        const sectionReslt = result?.percentage;
        Object.keys(sectionWithScore ?? {})?.forEach((key, index) => {
            // Use the section name with smart line breaks
            let sectionName = surveySections[key]?.name || '';

            // Dynamic line breaking logic based on text length and screen size
            const maxLength = isMobile ? 10 : 15; // Shorter threshold for mobile

            if (sectionName.length > maxLength) {
                const words = sectionName.split(' ');

                if (words.length === 1) {
                    // Single long word - no breaking possible
                    sectionName = sectionName;
                } else if (words.length === 2) {
                    // Two words - break between them
                    sectionName = words[0] + '\n' + words[1];
                } else if (words.length === 3) {
                    // Three words - try to balance the lines
                    const firstLineLength = words[0].length + words[1].length;
                    const secondLineLength = words[1].length + words[2].length;

                    if (firstLineLength <= secondLineLength) {
                        sectionName = words[0] + ' ' + words[1] + '\n' + words[2];
                    } else {
                        sectionName = words[0] + '\n' + words[1] + ' ' + words[2];
                    }
                } else {
                    // More than 3 words - break roughly in middle
                    const midPoint = Math.ceil(words.length / 2);
                    sectionName = words.slice(0, midPoint).join(' ') + '\n' + words.slice(midPoint).join(' ');
                }
            }

            indicators.push(getIndicator(sectionName, index))
            values.push(Number(sectionWithScore[key]))
        })
        //console.log("indicators", indicators)
        //console.log("values", values);
        //indicators.push(indicators.shift())
        // indicators.push(indicators)
        //Return if data
        if (indicators.length > 0 && values.length > 0) {
            //values.push(values.shift())
            //values.push(values)

            return {
                radar: {
                    indicator: indicators,
                    name: {
                        textStyle: {
                            fontSize: isMobile ? 12 : 14,
                            fontWeight: '500',
                            lineHeight: isMobile ? 14 : 18,
                            color: '#555',
                        },
                    },
                    splitNumber: intervalCount,
                    nameGap: isMobile ? 25 : 30,
                    radius: [0, isMobile ? 70 : 120],
                    center: ['50%', isMobile ? '55%' : '52%'],
                    label: {
                        show: true,
                        position: 'outside',
                        fontSize: 12,
                        lineHeight: 16,
                        fontWeight: '500',
                        color: '#222',
                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                        borderRadius: 12,
                        padding: [4, 4],
                        width: 15,
                        height: 15,
                        shadowBlur: 2,
                        shadowColor: 'rgba(0, 0, 0, 0.15)',
                        shadowOffsetX: 0,
                        shadowOffsetY: 2,
                        formatter: '{c}'
                    }
                },
                series: [
                    {
                        name: 'Digital Maturity Radar',
                        type: 'radar',
                        color: themeSet['--da-primary'],
                        lineStyle: {
                            width: 0
                        },
                        areaStyle: { // added areaStyle option here
                            color: themeSet['--da-primary'] + '50', // set the background color of the plotted area
                        },
                        data: [
                            {
                                value: values,
                                label: {
                                    show: true,
                                    position: 'outside',
                                    fontSize: 12,
                                    lineHeight: 16,
                                    fontWeight: '500',
                                    color: '#222',
                                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                    borderRadius: 12,
                                    padding: [4, 4],
                                    width: 15,
                                    height: 15,
                                    shadowBlur: 2,
                                    shadowColor: 'rgba(0, 0, 0, 0.15)',
                                    shadowOffsetX: 0,
                                    shadowOffsetY: 2,
                                    formatter: '{c}'
                                }
                            }
                        ]
                    }
                ]
            }
        }


        //Return this id there isn't any data
        return {
            radar: {
                indicator: [{ name: '', max: 10 }, { name: '', max: 10 }, { name: '', max: 10 }],
                name: {
                    textStyle: {
                        fontSize: isMobile ? 12 : 14,
                        fontWeight: '500',
                        lineHeight: isMobile ? 14 : 18,
                        color: '#555',
                    },
                },
                nameGap: isMobile ? 25 : 30,
                radius: [0, isMobile ? 70 : 120],
                center: ['50%', isMobile ? '55%' : '52%'],
            },
            series: [
                {
                    name: 'Digital Maturity Radar',
                    type: 'radar',
                    color: themeSet['--da-primary'],
                    lineStyle: {
                        width: 0
                    },
                    areaStyle: { // added areaStyle option here
                        color: themeSet['--da-primary'] + '50', // set the background color of the plotted area
                    },
                    data: [
                        {
                            value: [0],
                            label: {
                                show: true,
                                position: 'outside',
                                fontSize: 12,
                                lineHeight: 16,
                                fontWeight: '500',
                                color: '#222',
                                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                borderRadius: 12,
                                padding: [4, 4],
                                width: 15,
                                height: 15,
                                shadowBlur: 2,
                                shadowColor: 'rgba(0, 0, 0, 0.15)',
                                shadowOffsetX: 0,
                                shadowOffsetY: 2,
                                formatter: '{c}'
                            }
                        }
                    ]
                }
            ]
        }

    }, [surveySections, result, isMobile, themeSet])

    //Effects
    useEffect(() => {
        // Check if the window width is less than 768px (i.e., a mobile device)
        setIsMobile(window.innerWidth < 768);

        // Update the isMobile state variable whenever the window is resized
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, [])

    useEffect(() => {
        let token = localStorage.getItem("customer_token")
        if (!token || !ss_id || ss_id === 'undefined' || !survey_id) {
            navigate('/')
        }
        else {
            dispatch(getSurveySectionData({
                "survey_id": survey_id
            }))

            dispatch(getDefaultReport(survey_id))
            dispatch(getSurveyResult({ survey_id, ss_id }))
            dispatch(getSurveyDetail({
                "survey_id": survey_id
            }))

             dispatch(getLeadFormData({ survey_id }, navigate));
        }
    }, [survey_id, ss_id])

    useEffect(() => {
        if (surveyDetail.length > 0) {
            setTheme([surveyDetail[0].theme_selected]);
            setIsGraph(surveyDetail[0].is_graph);
            setIsAiReadiness(surveyDetail[0].show_readiness_progress);
            setGraphType(surveyDetail[0].graph_type);
            setDescription(surveyDetail[0].thankyou_description);
            
        }

    }, [surveyDetail])
    //Effects
    useEffect(() => {
        if (theme == 0 || theme == null) {
            setLogoImage('https://survey-bis.s3.ap-south-1.amazonaws.com/reportImg/a0e0d1d3-f39b-4a07-b7ec-8bea0c47c919_1705681254869_download.png');
        } else if (theme >= 1) {
            setLogoImage('https://survey-bis.s3.ap-south-1.amazonaws.com/logo/' + theme + '.svg');
        }
        setThemeSet(theme__[theme]);
    }, [theme]);

    const GaugeChartOptiopns = {
        series: [
            {
                type: "gauge",
                center: ["50%", "85%"],
                radius: "110%",
                startAngle: 180,
                endAngle: 0,
                min: 0,
                max: 100,
                splitNumber: 10,
                itemStyle: {
                    color: themeSet['--da-primary']
                },
                progress: {
                    show: true,
                    width: 20
                },

                pointer: {
                    show: false
                },
                axisLine: {
                    lineStyle: {
                        width: 15
                    }
                },
                axisTick: {
                    distance: -30,
                    splitNumber: 15,
                    lineStyle: {
                        width: 2,
                        color: themeSet['--da-primary'] + '50'
                    }
                },
                splitLine: {
                    distance: -40,
                    length: 14,
                    lineStyle: {
                        width: 3,
                        color: themeSet['--da-primary']
                    }
                },
                axisLabel: {
                    distance: -25,
                    color: themeSet['--da-primary'],
                    fontSize: 16
                },
                anchor: {
                    show: false
                },
                title: {
                    show: false
                },
                detail: {
                    valueAnimation: true,
                    width: "60%",
                    lineHeight: 40,
                    borderRadius: 8,
                    offsetCenter: [0, '-15%'],
                    fontSize: 50,
                    fontWeight: "bolder",
                    formatter: "{value}%",
                    color: "inherit"
                },
                data: [
                    {
                        value: percentage
                    }
                ]
            }
        ]
    };
    // Function to update GaugeChartOptions
    function updateChartOptions(options, gaugeValue) {
        // if (!options || !options.series || !options.series[0] || !options.series[0].axisLine || !options.series[0].axisTick || !options.series[0].splitLine || !options.series[0].axisLabel || !options.series[0].detail) {
        //     return options; // Return original options if critical parts are not defined
        // }
        //options.series[0].data[0].value = 67;
        if (gaugeValue !== undefined) {
            options.series[0].data[0].value = percentage;
        }
        // if (chartColor) {
        //     options.series[0].itemStyle.color = chartColor;

        // }

        // if (textColor) {
        //     options.series[0].axisLabel.color = textColor;
        //     options.series[0].splitLine.lineStyle.color = textColor;
        //     options.series[0].axisTick.lineStyle.color = textColor;
        // }

        // if (min !== undefined && max !== undefined) {
        //     options.series[0].min = min;
        //     options.series[0].max = max;
        // }

        // if (interval !== undefined) {
        //     options.series[0].splitNumber = Math.ceil((max - min) / interval);
        // }

        return options;
    }

//     const handleViewReport = async (e) => {
//          if (displayForm === "Before survey") {
//         if (survey_id === 'b6420220-5ba7-11ef-b484-6dfb5d512f67') {
//             const hs_object_id = localStorage.getItem('hs_object_id');
//             if (hs_object_id) {
//                 const reportUrl = `${window.location.protocol}//${window.location.host}/report/${survey_id}/${ss_id}/${defaultReport?.default_report}`;
//                 await fetch(`${process.env.REACT_APP_API_URL}/survey/patchAPI`, {
//                     method: 'POST',
//                     headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
//                     body: `userId=${encodeURIComponent(hs_object_id)}&action=external_url&value=${encodeURIComponent(reportUrl)}`
//                 });
//             }
//         }
//     }
//       else if (displayForm === "Before report") {
//  const hasInfo = await checkLeadInfo(ss_id);
//     if (hasInfo) {
//       // Info present, proceed as usual
//       navigate(`/report/${survey_id}/${ss_id}/...`);
//     } else {
//       // Info missing, show modal
//       setShowLeadFormModal(true);
//     }
//           }
//         }

const REPORT_URL = `/report/${survey_id}/${ss_id}/${defaultReport?.default_report}`;

const handleViewReport = async (e) => {
  e?.preventDefault?.();

  // 1. DisplayForm === "Before Survey" → behave exactly as it currently does
  if (displayForm === "Before survey") {
    // keep your existing HubSpot patch call (if any)
    if (survey_id === 'b6420220-5ba7-11ef-b484-6dfb5d512f67') {
      const hs_object_id = localStorage.getItem('hs_object_id');
      if (hs_object_id) {
        const reportUrl = `${window.location.protocol}//${window.location.host}${REPORT_URL}`;
        await fetch(`${process.env.REACT_APP_API_URL}/survey/patchAPI`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: `userId=${encodeURIComponent(hs_object_id)}&action=external_url&value=${encodeURIComponent(reportUrl)}`
        });
      }
    }
    navigate(REPORT_URL);
    return;
  }else if (displayForm === "Before report") {
    try {
      const hasInfo = await checkLeadInfo(ss_id);
      console.log("hasInfo",hasInfo);
      if (hasInfo==true) {
        navigate(REPORT_URL);
      } else {
        setAfterLeadAction('view');
        setShowLeadFormModal(true);
        openFormIfNeeded();
      }
    } catch (err) {
      setShowLeadFormModal(true);
      openFormIfNeeded();
    }
    return;
  }

  // default fallback
  navigate(REPORT_URL);
};

    

 const language = "22"; // same as LandingPage
 const containsHTML = (v) => !(/<\/?[a-z][\s\S]*?>/i).test(v || "");
 const noConsecutiveSpecialChars = (v) => !(/[@$#%^&*!?]{2,}/).test(v || "");
 const containsForbiddenCharacters = (v) => !(/[^a-zA-Z0-9 ]/).test(v || "");

 const schemaShape = useMemo(() => {
  const shape = {};
   (leadFormData || []).forEach(item => {
     if (isLeadFormFieldHidden(item)) return;

     const title = item.su_label_and_options ? JSON.parse(item.su_label_and_options)[language] : "";
     const key = item.su_name;
     const type = item.su_form_variable_type;
     const opt = item.su_options && JSON.parse(item.su_options);

     const baseString = Yup.string()
       .test("ws", `${title} can not start with white space`, v => !v || v[0] !== " ")
       .test("html", `${title} contains forbidden HTML tags`, v => !v || containsHTML(v))
        .test("forbidden", `${title} contains invalid characters`, v => !v || containsForbiddenCharacters(v))
       .test("spec", `${title} contains special characters`, v => !v || noConsecutiveSpecialChars(v))
       .max(255, `${title} is too long`);
       const baseStringForEmail = Yup.string()
  .test("ws", `${title} can not start with white space`, v => !v || v[0] !== " ")
  .test("html", `${title} contains forbidden HTML tags`, v => !v || containsHTML(v))
  .test("spec", `${title} contains special characters`, v => !v || noConsecutiveSpecialChars(v))
  .max(255, `${title} is too long`);
     if (type === 1) {
       const a = opt?.["0"];
            if (a?.type === "email") {
        let y = baseStringForEmail.email("Invalid email").test("biz", "Please enter valid business email address", v => {
            if (!v || a.businessEmailVerification === false) return true;
            const domain = v.split("@")[1];
            return !["gmail.com","outlook.com","hotmail.com","yahoo.com"].includes(domain);
        });
        shape[key] = a?.required ? y.required(`${title} Required`) : y;
        } else if (a?.type === "checkbox") {
         const arr = Yup.array().of(Yup.string());
         shape[key] = a?.required ? arr.min(1, `${title} Required`) : arr;
       } else if (a?.required) {
         shape[key] = baseString.required(`${title} Required`);
       } else {
         shape[key] = baseString.optional();       }
     } else if (type === 3 || type === 12 || type === 13) {
       shape[key] = (opt?.required) ? Yup.string().required(`${title} Required`) : Yup.string();
     } else if (type === 4) {
       const s = opt?.required ? Yup.string().required(`${title} Required`) : Yup.string();
       shape[key] = s.test("html", `${title} contains forbidden HTML tags`, v => !v || containsHTML(v));
     } else if (type === 99) {
       const required = opt?.required && opt?.term;
       if (required) shape[key] = Yup.string().oneOf(["on"], "").required("Please accept conditions to go ahead");
       else shape[key] = Yup.string();
     }
   });
   return shape;
 }, [leadFormData]);

 const initialValues = useMemo(() => {
   const vals = {};
   (leadFormData || []).forEach(item => {
     if (isLeadFormFieldHidden(item)) return;

     const key = item.su_name;
     vals[key] = "";
     if (Number(item.su_form_variable_type) === 1) {
       const opt = item?.su_options && JSON.parse(item.su_options);
       if (opt?.["0"]?.type === "checkbox") vals[key] = [];
     }
     if (Number(item.su_form_variable_type) === 5) {
      const opt = item?.su_options && JSON.parse(item.su_options);
       vals[key] = opt?.["0"]?.defaultValue;
     }
  });
   return vals;
 }, [leadFormData]);



  useEffect(() => {
   if (!leadFormData?.length) return;

   setTandC("");
   setTandCSecond("");
   setTandCThird("");
   setTandCOption({});
   setTandCSecondOption({});
   setTandCThirdOption({});

   leadFormData.forEach(item => {
     const key = item.su_name;
     const labelObj = item.su_label_and_options && JSON.parse(item.su_label_and_options);
     const label = labelObj ? labelObj[language] : "";

    if (key === "HEADING") setHeading(label);
    if (key === "SUBMIT") {
       setSubmitTitle(label);
       let pos = item.su_options && JSON.parse(item.su_options)?.alignment || "Left";
       setSubmitPosition(pos === "Left" ? "start" : pos === "Right" ? "end" : "center");
     }
     if (key === "TANDC") {
       setTandC(label);
       setTandCOption(JSON.parse(item.su_options) || {});
     }
     if (key === "TANDCSECOND") {
       setTandCSecond(label);
       setTandCSecondOption(JSON.parse(item.su_options) || {});
    }
     if (key === "TANDCTHIRD") {
       setTandCThird(label);
       setTandCThirdOption(JSON.parse(item.su_options) || {});
     }
     if (key === "email") {
       const opt = JSON.parse(item?.su_options);
      setEmailVerify(opt?.[0]?.emailVerification);
      setEmailValidationTiming(opt?.[0]?.emailValidationTiming);
     }
      if (key === "DISPLAYFORM") {
      
      const val = JSON.parse(item?.su_options)?.value || "Before survey";
      setDisplayForm(val);
     }

     
   });
 }, [leadFormData]);

  useEffect(() => {
    const isBeforeReport =
      (displayForm || "").trim().toLowerCase() === "before report";
    if (!isBeforeReport || !ss_id || utmAttachedRef.current) return;
    const url = new URL(window.location.href);
    const hasUtm =
      url.searchParams.get("utm_source") ||
      url.searchParams.get("utm_medium") ||
      url.searchParams.get("utm_campaign") ||
      url.searchParams.get("utm_content");
    if (hasUtm) {
      utmAttachedRef.current = true;
      return;
    }
    attachUtmToUrlFromDb()
      .finally(() => {
        utmAttachedRef.current = true;
      });
  }, [attachUtmToUrlFromDb, displayForm, ss_id]);


  const Schema = useMemo(() => Yup.object().shape(schemaShape), [schemaShape]);

 const formik = useFormik({
   enableReinitialize: false,
   initialValues,
   validationSchema: Schema,
   onSubmit: async (values) => {
     const params = new URLSearchParams(window.location.search);
     const payload = {
       lead_data: {
         ...values,
         natureOfEnquiry: "More info on Cloud and Hosting",
       },
       survey_id,
       su_lead_info: JSON.stringify(params),
       lid: params.get("lid"),
       leadManagementPlugin: 0,
       emailVerification: emailVerify,
       emailValidationTiming,
       utm_campaign: params.get("utm_campaign") || "default_campaign",
       utm_medium: params.get("utm_medium") || "default_medium",
       utm_source: params.get("utm_source") || "default_source",
     };

    if ((displayForm || '').trim().toLowerCase() === "before report") {
        await handleLeadFormSubmit(values); // This will update the dummy entry and navigate
        return;
        }
     if (emailVerify && emailValidationTiming === "before") {
       setFlagFormStep(2);
       try {         const resp = await dispatch(submitLeadFormData(payload, navigate));
         setSubLoading(true);
         setLeadId(resp?.ss_id);
       } catch (e) {
         setSubLoading(false);
         toast.error("Form submit failed");
       }
     } else {
       dispatch(submitLeadFormData(payload, navigate));
       setSubLoading(true);
     }   },
 });


 const checkLeadInfo = async (ss_id) => {
  const response = await Axios.post(`${process.env.REACT_APP_API_URL}/frnt/check-lead-info`, { ss_id });
   console.log("response",response);
  return response.data.hasInfo; // <-- use response.data.hasInfo
};

const handleLeadFormSubmit = async (formData) => {
     const modal = document.getElementById("leadFormModal");
  if (modal && window.bootstrap) {
    const bsModal = window.bootstrap.Modal.getOrCreateInstance(modal);
    bsModal.hide();
  } else if (modal && window.$) {
    window.$(modal).modal("hide");
  }

  await Axios.post(`${process.env.REACT_APP_API_URL}/frnt/update-lead-info`, { ss_id, su_lead_info: formData });
  setShowLeadFormModal(false);
  const response = await checkLeadInfo(ss_id);
  setHasLeadInfo(response);
  // Optionally reflect report url to HubSpot after mapping
  try {
    const hs_object_id = localStorage.getItem('hs_object_id');
    if (hs_object_id) {
      const reportUrl = `${window.location.protocol}//${window.location.host}/report/${survey_id}/${ss_id}/${defaultReport?.default_report}`;
      await fetch(`${process.env.REACT_APP_API_URL}/survey/patchAPI`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: `userId=${encodeURIComponent(hs_object_id)}&action=external_url&value=${encodeURIComponent(reportUrl)}`
      });
    }
  } catch (e) {}
  // Now navigate to report
  //navigate(`/report/${survey_id}/${ss_id}/${defaultReport?.default_report}`);
      clearPendingAuthAction();
      if (afterLeadAction === 'download') {
      setAutoActionUi("download");
      // trigger pdf download
      setTimeout(() => {
        printDocument();
      }, 150);
    } else {
      setAutoActionUi("view");
      // default / previous behaviour
      setTimeout(() => {
        navigate(`/report/${survey_id}/${ss_id}/${defaultReport?.default_report}`);
      }, 150);
    }
};


useEffect(() => {
  if (showLeadFormModal) {
    // Use Bootstrap's JS API to show the modal
    const modal = document.getElementById("leadFormModal");
    if (modal) {
      // If using Bootstrap 5
      if (window.bootstrap) {
        const bsModal = window.bootstrap.Modal.getOrCreateInstance(modal);
        bsModal.show();
      } else if (window.$) {
        // fallback for Bootstrap 4 with jQuery
        window.$(modal).modal("show");
      }
    }
  }
}, [showLeadFormModal]);


useEffect(() => {
  const check = async () => {
    if (ss_id) {
      const response = await checkLeadInfo(ss_id);
      setHasLeadInfo(response); // response is true/false
    }
  };
  check();
}, [ss_id]);

useEffect(() => {
  autoActionHandledRef.current = false;
  setAutoActionUi(null);
}, [survey_id, ss_id]);

useEffect(() => {
  const isBeforeReport = (displayForm || "").trim().toLowerCase() === "before report";
  if (!isBeforeReport || !hasLeadInfo || autoActionHandledRef.current) return;

  const intent = afterLeadAction || getPendingAuthAction();
  if (!intent) return;
  if (!defaultReport?.default_report) return;

  autoActionHandledRef.current = true;
  clearPendingAuthAction();
  setAfterLeadAction(null);

  setAutoActionUi(intent);
  if (intent === "download") {
    setTimeout(() => {
      printDocument();
    }, 150);
  } else {
    setTimeout(() => {
      navigate(`/report/${survey_id}/${ss_id}/${defaultReport?.default_report}`);
    }, 150);
  }
}, [displayForm, hasLeadInfo, afterLeadAction, defaultReport, navigate, survey_id, ss_id]);

useEffect(() => {
  const el = document.getElementById("leadFormModal");
  if (!el || !window.bootstrap) return;

  const handleHidden = () => {
    setShowLeadFormModal(false);      // allow it to be opened again
    setAfterLeadAction(null);         // (optional) clear intent
  };

  el.addEventListener("hidden.bs.modal", handleHidden);
  return () => el.removeEventListener("hidden.bs.modal", handleHidden);
}, []);

const showAiVersion =
  isAiReadiness === 1 &&
  isGraph === 1 &&
  graphType === "spider_nolegend";

  const pageClass = showAiVersion
  ? "thank-you-page ai-version p-0 d-flex flex-column"
  : "thank-you-page";

    const handleHubspotAuth = () => {
    let ehValue = "EH_20"; // default value
    
    if (survey_id === "622b2280-16ae-11f0-94ea-9574364caebe") {
      ehValue = "EH_23";
    } else if (survey_id === "7cb2a510-151e-11f0-998d-f7cbc9c2d788") {
      ehValue = "EH_24";
    }
    
    window.location.href = buildLoginUrl(ehValue);
  };

  useEffect(() => {
    if (!leadFormData || !leadFormData.length) return;

    const params = new URLSearchParams(window.location.search);
    let token = params.get("e");
    const rawEmail = params.get("email");

    if (!token && rawEmail) {
      const minted = encryptEmail(rawEmail);
      const url = new URL(window.location.href);
      url.searchParams.delete("email");
      url.searchParams.set("e", minted);
      window.history.replaceState({}, "", url.toString());
      token = minted;
    }

    if (!token) return;
    const email = decryptToken(token);
    if (!email) return;

    (async () => {
      const hubUser = await fetchHubspotUser(email);
      if (!hubUser) return;

      if (hubUser.hs_object_id) {
        localStorage.setItem('hs_object_id', hubUser.hs_object_id);
      }

      const prefill = {
        email: hubUser.email || '',
        firstName: hubUser.firstname || '',
        lastName: hubUser.lastname || '',
        company: hubUser.company || '',
        busPhone: (hubUser.phone || '').replace(/^(\+91[\s-]*)/, ''),
        state: hubUser.state || '',
        designation: hubUser.designation_ || hubUser.designation || '',
        country: hubUser.country || '',
        TANDC: 'on'
      };

      try {
        formik.setValues({ ...formik.values, ...prefill });
      } catch {}

      // Immediately and silently store HubSpot data; do not open modal or auto-navigate
      await silentSubmitLeadInfo(prefill);
    })();
  }, [leadFormData]);

  // Recover missing ss_id from localStorage or create a dummy session
  useEffect(() => {
    (async () => {
      if (!survey_id) return;
      if (ss_id && ss_id !== 'null' && ss_id !== 'undefined') return;

      // Try recover from latest snapshot
      const latestKey = localStorage.getItem('latest_survey_key');
      if (latestKey) {
        try {
          const raw = localStorage.getItem(latestKey);
          const snap = raw ? JSON.parse(raw) : null;
          if (snap && snap.survey_id === survey_id && snap.ss_id) {
            navigate(`/report/${survey_id}/${snap.ss_id}/${defaultReport?.default_report ? defaultReport?.default_report : ''}`.replace(/\/$/, ''), { replace: true });
            return;
          }
        } catch (e) {}
      }

      // Fallback: ask backend to init a session and redirect to canonical thank-you URL
      try {
        const resp = await Axios.post(`${process.env.REACT_APP_API_URL}/frnt/init-session`, { survey_id });
        const newId = resp?.data?.ss_id;
        if (newId) {
          navigate(`/thank-you/${survey_id}/${newId}`, { replace: true });
        }
      } catch (e) {
        // swallow
      }
    })();
  }, [survey_id, ss_id]);


    return (
      <>
        {showProcessingOverlay && (
          <div
            style={{
              position: "fixed",
              inset: 0,
              zIndex: 9999,
              backgroundColor: "rgba(0, 0, 0, 0.75)",
              backdropFilter: "blur(4px)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "20px",
              animation: "fadeIn 0.2s ease-in-out"
            }}
          >
            <div
              style={{
                width: "100%",
                maxWidth: "520px",
                background: "#ffffff",
                borderRadius: "12px",
                boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(0, 0, 0, 0.1)",
                padding: "32px",
                textAlign: "center",
                animation: "slideUp 0.3s ease-out"
              }}
            >
              <div
                style={{
                  width: "56px",
                  height: "56px",
                  margin: "0 auto 20px",
                  background: "linear-gradient(135deg, var(--da-primary, #0079E5) 0%, #0056b3 100%)",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0 4px 12px rgba(0, 121, 229, 0.3)"
                }}
              >
                <div
                  className="spinner-border text-white"
                  role="status"
                  style={{ width: "28px", height: "28px", borderWidth: "3px" }}
                >
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
              
              <h3
                style={{
                  margin: "0 0 8px 0",
                  fontSize: "22px",
                  lineHeight: 1.3,
                  fontWeight: 600,
                  color: "#1a202c",
                  letterSpacing: "-0.01em"
                }}
              >
                {processingTitle}
              </h3>
              
              <p
                style={{
                  margin: "0 0 20px 0",
                  color: "#64748b",
                  fontSize: "15px",
                  lineHeight: 1.5
                }}
              >
                {processingMessage}
              </p>
              
              <div
                style={{
                  padding: "12px 16px",
                  background: "#f8fafc",
                  borderRadius: "8px",
                  border: "1px solid #e2e8f0"
                }}
              >
                <p
                  style={{
                    margin: 0,
                    fontSize: "13px",
                    color: "#64748b",
                    fontWeight: 500
                  }}
                >
                  This may take 6–8 seconds • Please do not close this page
                </p>
              </div>
              
              <div
                className="progress"
                style={{
                  height: "4px",
                  borderRadius: "999px",
                  backgroundColor: "#e2e8f0",
                  overflow: "hidden",
                  marginTop: "20px"
                }}
              >
                <div
                  className="progress-bar progress-bar-striped progress-bar-animated"
                  role="progressbar"
                  style={{
                    width: "100%",
                    backgroundColor: "var(--da-primary, #0079E5)"
                  }}
                  aria-valuenow={100}
                  aria-valuemin={0}
                  aria-valuemax={100}
                />
              </div>
            </div>
            
            <style>{`
              @keyframes fadeIn {
                from { opacity: 0; }
                to { opacity: 1; }
              }
              @keyframes slideUp {
                from {
                  opacity: 0;
                  transform: translateY(20px) scale(0.95);
                }
                to {
                  opacity: 1;
                  transform: translateY(0) scale(1);
                }
              }
            `}</style>
          </div>
        )}
        
        <div
          dangerouslySetInnerHTML={{
            __html:
              "<style type='text/css'> :root { --font-family: " +
              themeSet["--font-family"] +
              "; --da-primary: " +
              themeSet["--da-primary"] +
              " !important; --da-secondary: " +
              themeSet["--da-secondary"] +
              " !important; --progress-1: " +
              themeSet["--progress-1"] +
              " !important; --progress-2: " +
              themeSet["--progress-2"] +
              " !important; --progress-3: " +
              themeSet["--progress-3"] +
              " !important; --progress-4: " +
              themeSet["--progress-4"] +
              " !important; --progress-5: " +
              themeSet["--progress-5"] +
              " !important; } </style>",
          }}
        />
        <div className={pageClass}>
          {isAiReadiness === 1 && graphType === "spider_nolegend" && (
           <div className="header-wrap">
                    <div className="wrapper d-flex justify-content-between align-items-end">

                        <div className="logo-wrap left-logo">
                            <img src={logoImage} alt="" />
                        </div>
                        <div className="logo-wrap right-logo">
                            <img src={logoImage2} alt="" />
                        </div>
                    </div>
                </div>
             )}
            <div
      className={
        showAiVersion
          ? "main-area flex-grow-1 d-flex align-items-center"
          : undefined
      }
    >
          <div className="container" id="container1234">
            <div className="row">
              {isAiReadiness === 1 ? (
                <div
                  className={`mb-3 mb-lg-0 ${
                    isGraph && isGraph === 1 ? "col-lg-6" : "col-lg-12"
                  }`}
                >
                  <div className="text-wrap">
                    {/* <h1><span className='text-primary'>{`${result?.info?.con_first_name ?? (result?.info?.firstName ?? '')} ${result?.info?.con_last_name ?? (result?.info?.lastName ?? '')}`},</span> {`${result?.info?.company ?? ''}`} is at the <span className='text-primary'>{result?.stage && `${result?.stage}`}</span> stage</h1> */}
                    <h1>
                      Thank You{" "}
                      <span className="text-primary">
                        {`${
                          result?.info?.con_first_name ??
                          result?.info?.firstName ??
                          ""
                        } ${
                          result?.info?.con_last_name ??
                          result?.info?.lastName ??
                          ""
                        }`}
                        
                      </span>{" "}
                      for completing the AI Maturity Assessment
                    </h1>

                    <div className="stat-data-wrap">
                      <div className="stat-data-item">
                        <span className="text-primary">
                          Your overall score:&nbsp;
                        </span>
                        <span className="text-secondary">
                          {result?.overall_maturity_score1}
                        </span>
                      </div>
                      <div className="stat-data-item ">
                        <span className="text-primary">
                          AI Readiness:&nbsp;
                        </span>
                        <span className="text-secondary"> {result?.stage}</span>
                      </div>
                    </div>

                    <p>{description}</p>
                    <div className="button-wrap d-flex flex-wrap align-items-center">
                      {/* <button
                        type="button"
                        className="btn btn-primary me-0 me-md-3 mb-3"
                        // data-bs-toggle="modal"
                        // data-bs-target="#leadFormModal"
                        // onClick={openFormIfNeeded}
                        onClick={handleViewReport}
                      >
                           {(displayForm || '').trim().toLowerCase() === "before report"
                          ? "Signup to View Report"
                          : "View Report"}
                      </button> */}
                      <button
                        type="button"
                        className="btn btn-primary me-0 me-md-3 mb-3"
                        // onClick={() => {
                        //   if (
                        //     (displayForm || "").trim().toLowerCase() ===
                        //     "before report"
                        //   ) {
                        //     if (hasLeadInfo) {
                        //       // Directly navigate to report
                        //       navigate(
                        //         `/report/${survey_id}/${ss_id}/${defaultReport?.default_report}`
                        //       );
                        //     } else {
                        //       // Open
                        //       setAfterLeadAction("view");
                        //       setShowLeadFormModal(true);
                        //       openFormIfNeeded();
                        //       const el =
                        //         document.getElementById("leadFormModal");
                        //       if (el && window.bootstrap) {
                        //         window.bootstrap.Modal.getOrCreateInstance(
                        //           el
                        //         ).show();
                        //       }
                        //     }
                        //   } else {
                        //     handleViewReport();
                        //   }
                        // }}
                        onClick={() => {
                          if (actionLock) return;
                          if ((displayForm || "").trim().toLowerCase() === "before report" && !hasLeadInfo) {
                            startSignup("view");
                          } else {
                            navigate(`/report/${survey_id}/${ss_id}/${defaultReport?.default_report}`);
                          }
                        }}
                        disabled={actionLock}
                      >
                        {viewReportLabel}
                      </button>
                     

                      {/* <button
                        className="btn btn-transparent btn-icon mb-3"
                        onClick={printDocument}
                        disabled={isLoading}
                      >
                        Download report
                        {isLoading ? (
                          <div
                            className="spinner-border text-primary"
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        ) : (
                          <Svg name="button-icon" />
                        )}
                      </button> */}
                      <button
                        className="btn btn-transparent btn-icon mb-3"
                        onClick={() => {
                          if (actionLock) return;
                          const isBeforeReport = (displayForm || "").trim().toLowerCase() === "before report";
                          if (isBeforeReport && !hasLeadInfo) {
                            startSignup("download");
                          } else {
                            printDocument();
                          }
                        }}
                        disabled={isLoading || actionLock}
                      >
                        {downloadReportLabel}
                        {isLoading ? (
                          <div
                            className="spinner-border text-primary"
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        ) : (
                          <Svg name="button-icon" />
                        )}
                      </button>
                    </div>
                    {/*Desclaimer text */}
                    <div className="desclaimer fs-10">
                     <strong>Disclaimer: </strong>By continuing with this assessment report, you agree and acknowledge that it is a preliminary, indicative and non-conclusive result of the survey maturity of your organisation based upon the information provided by you and is subject to change. This is only for your internal consumption and not for publications or any unauthorised usage or circulation. Tata Communications™ disclaims any and all claims & liabilities associated with this report.
                    </div>
                  </div>
                </div>
              ) : (
                <div
                  className={`mb-3 mb-lg-0 ${
                    isGraph && isGraph === 1 ? "col-lg-6" : "col-lg-12"
                  }`}
                >
                  <div className="text-wrap">
                    <div className="logo-wrap">
                      <img src={logoImage} alt="" />
                    </div>
                    <h1>
                      <span className="text-primary">
                        {`${
                          result?.info?.con_first_name ??
                          result?.info?.firstName ??
                          ""
                        } ${
                          result?.info?.con_last_name ??
                          result?.info?.lastName ??
                          ""
                        }`}
                        ,
                      </span>{" "}
                      {`${result?.info?.company ?? ""}`} is at the{" "}
                      <span className="text-primary">
                        {result?.stage && `${result?.stage}`}
                      </span>{" "}
                      stage
                    </h1>

                    <div className="progress-wrapper">
                      <div className="progress-output">
                        <ul progress-width="50">
                          {Object.keys(result?.all_stages ?? {})?.map(
                            (key, index) => {
                              return (
                                <li
                                  className={`${
                                    result?.stage &&
                                    `${result?.stage}`.toLowerCase() ===
                                      `${result?.all_stages[key]}`.toLowerCase()
                                      ? "active"
                                      : ""
                                  } icon-text-wrap`}
                                >
                                  <div className="icon-wrap">
                                    <div className="count">{index + 1}</div>
                                    <Svg name="beginner-icon" />
                                  </div>
                                  <div className="text">
                                    {result?.all_stages[key]}
                                  </div>
                                </li>
                              );
                            }
                          )}
                          {/* <li className={`${result?.stage && (`${result?.stage}`.toLowerCase() === 'cloud novice' || `${result?.stage}`.toLowerCase() === 'cloud explorer' || `${result?.stage}`.toLowerCase() === 'cloud innovator') ? 'active' : ''} icon-text-wrap`}>
                                                <div className="icon-wrap">
                                                    <div className="count">
                                                        1
                                                    </div>
                                                    <Svg name="beginner-icon" />
                                                </div>
                                                <div className="text">Cloud Novice</div>
                                            </li>
                                            <li className={`${result?.stage && (`${result?.stage}`.toLowerCase() === 'cloud explorer' || `${result?.stage}`.toLowerCase() === 'cloud innovator') ? 'active' : ''} icon-text-wrap`}>
                                                <div className="icon-wrap">
                                                    <div className="count">
                                                        2
                                                    </div>
                                                    <Svg name="intermediate-icon" />
                                                </div>
                                                <div className="text">Cloud Explorer</div>
                                            </li>
                                            <li className={`${result?.stage && (`${result?.stage}`.toLowerCase() === 'cloud innovator') ? 'active' : ''} icon-text-wrap`}>
                                                <div className="icon-wrap">
                                                    <div className="count">
                                                        3
                                                    </div>
                                                    <Svg name="advanced-icon" />
                                                </div>
                                                <div className="text">Cloud Innovator</div>
                                            </li> */}
                          {/* Change progress width, if stage is beginner, width is 0 and if advanced width is 100 */}
                          {/* <div className="result-bar" style={{ width: `${result?.stage}`.toLowerCase() === 'cloud innovator' ? '100%' : `${result?.stage}`.toLowerCase() === 'cloud explorer' ? '50%' : '0%' }}> </div> */}
                        </ul>
                      </div>
                    </div>

                    <p>{description}</p>
                    <div className="button-wrap d-flex flex-wrap align-items-center">
                      {/* <Link
                        to={`/report/${survey_id}/${ss_id}/${defaultReport?.default_report}`}
                        className="btn btn-primary me-0 me-md-3 mb-3"
                        onClick={handleViewReport}
                      >
                        {" "}
                        View report{" "}
                      </Link> */}
                      <button
                        type="button"
                        className="btn btn-primary me-0 me-md-3 mb-3"
                        onClick={() => {
                          if (actionLock) return;
                          if (
                            (displayForm || "").trim().toLowerCase() ===
                              "before report" &&
                            !hasLeadInfo
                          ) {
                            setAfterLeadAction("view");
                            setShowLeadFormModal(true);
                            openFormIfNeeded();
                            const el = document.getElementById("leadFormModal");
                            if (el && window.bootstrap) {
                              window.bootstrap.Modal.getOrCreateInstance(
                                el
                              ).show();
                            }
                          } else {
                            navigate(
                              `/report/${survey_id}/${ss_id}/${defaultReport?.default_report}`
                            );
                          }
                        }}
                        disabled={actionLock}
                      >
                        {viewReportLabel}
                      </button>
                      
                      {/* <button
                        className="btn btn-transparent btn-icon mb-3"
                        onClick={printDocument}
                        disabled={isLoading}
                      >
                        Download report
                        {isLoading ? (
                          <div
                            className="spinner-border text-primary"
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        ) : (
                          <Svg name="button-icon" />
                        )}
                      </button> */}
                      <button
                        className="btn btn-transparent btn-icon mb-3"
                        onClick={() => {
                          if (actionLock) return;
                          const isBeforeReport = (displayForm || "").trim().toLowerCase() === "before report";
                          if (isBeforeReport && !hasLeadInfo) {
                            startSignup("download");
                          } else {
                            printDocument();
                          }
                        }}
                        disabled={isLoading || actionLock}
                      >
                        {downloadReportLabel}
                        {isLoading ? (
                          <div
                            className="spinner-border text-primary"
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        ) : (
                          <Svg name="button-icon" />
                        )}
                      </button>
                    </div>
                    {/*Desclaimer text */}
                    <div className="desclaimer fs-10">
                      <strong>Disclaimer: </strong>By continuing with this
                      assessment report, you agree and acknowledge that it is a
                      preliminary, indicative and non-conclusive result of the
                      survey maturity of your organisation based upon the
                      information provided by you and is subject to change. This
                      is only for your internal consumption and not for
                      publications or any unauthorised usage or circulation.
                      Tata Communications™ disclaims any and all claims &
                      liabilities associated with this report.
                    </div>
                  </div>
                </div>
              )}

              {isGraph === 1 &&
                (graphType && graphType === "spider" ? (
                  <div className="col-lg-6">
                    <div className="graph-box">
                      <div className="chart-wrapper">
                        <ReactEcharts style={style} option={option} />
                      </div>
                      <div className="value-wrapper">
                        {Object.keys(result?.section_maturity_score ?? {})?.map(
                          (key, index) => (
                            <div
                              className={`value-box value-${(index % 6) + 1}`}
                              key={index}
                            >
                              <div className="number">
                                {result?.section_maturity_score[key]}
                              </div>
                              <div className="text">
                                {surveySections[key]?.name}
                              </div>
                            </div>
                          )
                        )}
                      </div>
                    </div>
                  </div>
                ) : graphType && graphType === "spider_nolegend" ? (
                  <div className="col-lg-6">
                    <div className="graph-box">
                      <div className="chart-wrapper">
                        <ReactEcharts style={style} option={option} />
                      </div>

                      {/* <div className="value-wrapper">
                                                {Object.keys(result?.section_maturity_score ?? {})?.map((key, index) => (
                                                    <div className={`value-box value-${(index % 6) + 1}`} key={index}>
                                                        <div className="number">{(result?.section_maturity_score[key])}</div>
                                                        <div className="text">{surveySections[key]?.name}</div>
                                                    </div>
                                                ))}
                                            </div> */}
                    </div>
                  </div>
                ) : (
                  <div className="col-lg-6">
                    <div className="graph-box">
                      <div className="chart-wrapper">
                        <div className="text-center chart-title">
                          Your SOC readiness radar
                        </div>
                        {(() => {
                          const updatedOptions = updateChartOptions(
                            GaugeChartOptiopns,
                            percentage
                          );
                          return (
                            <ReactEcharts
                              style={styleGauge}
                              option={updatedOptions}
                            />
                          );
                        })()}
                      </div>
                    </div>
                  </div>
                ))}
            </div>
            {isGraph === 1 && graphType && graphType === "spider_nolegend" && (
              <div className="row gx-5">
                <div className="col-lg-6"></div>
                <div className="col-lg-6">
                  <p className="text-center text-graph-desc">
                    Each category is rated on a scale from 1 to 5.
                  </p>
                </div>
              </div>
            )}
          </div>
          </div>
        </div>

        {/* <div className='SurveyReportPreview' id='SurveyReportPreview' ref={pdfRef} style={{ display: 'block' }}>
                <Report SRID={defaultReport?.default_report} />
            </div> */}

        {/* Thank you page  AI version */}

        {showLeadFormModal && leadFormData?.length > 0 && (
          <div
            className="modal"
            id="leadFormModal"
            tabIndex={-1}
            aria-labelledby="leadFormModalLabel"
            aria-hidden="true"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
          >
            <div className="modal-dialog modal-dialog-centered modal-lg">
              <div className="modal-content lead-gen-wrapper">
                <div className="modal-body position-relative">
                  <button
                    type="button"
                    className="btn-close position-absolute"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    style={{ top: "20px", right: "20px", zIndex: "10" }}
                  />
                  <div className="lead-gen-wrapper bg-transparent">
                    <div className="text-wrapper">
                      <div className="text-inner p-4">
                        <div className="heading-wrapper">
                          <h1>
                          <h1>{heading ?? ""}</h1>
                          </h1>
                        </div>
                        <div className="form-wrapper">
                          {flagFormStep === 1 && (
                            <form onSubmit={formik.handleSubmit}>
                              <div className="row">
                                {leadFormData?.map((item) => (
                                  <CustomInput
                                    key={item.su_name}
                                    fieldData={item}
                                    className={"mb-4"}
                                    formikData={formik}
                                  />
                                ))}
                              </div>

                              {(TandC || TandCSecond || TandCThird) && (
                                <div className="">
                                  <p>Terms & Conditions</p>
                                </div>
                              )}

                              {TandC && (
                                <div className="terms-form-wrap">
                                  {TandCOption.term !== false && (
                                    <div className="form-check">
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="TANDC"
                                        name="TANDC"
                                        onChange={(e) =>
                                          formik.setFieldValue(
                                            "TANDC",
                                            e.target.checked ? "on" : ""
                                          )
                                        }
                                        onBlur={formik.handleBlur}
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor="TANDC"
                                        dangerouslySetInnerHTML={asHTML(TandC)}
                                      />
                                    </div>
                                  )}
                                  {formik.touched.TANDC &&
                                    formik.errors.TANDC && (
                                      <div className="error">
                                        {formik.errors.TANDC}
                                      </div>
                                    )}
                                </div>
                              )}

                              {TandCSecond && (
                                <div className="terms-form-wrap">
                                  {TandCSecondOption.term !== false && (
                                    <div className="form-check">
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="TANDCSECOND"
                                        name="TANDCSECOND"
                                        onChange={(e) =>
                                          formik.setFieldValue(
                                            "TANDCSECOND",
                                            e.target.checked ? "on" : ""
                                          )
                                        }
                                        onBlur={formik.handleBlur}
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor="TANDCSECOND"
                                        dangerouslySetInnerHTML={asHTML(
                                          TandCSecond
                                        )}
                                      />
                                    </div>
                                  )}
                                  {formik.touched.TANDCSECOND &&
                                    formik.errors.TANDCSECOND && (
                                      <div className="error">
                                        {formik.errors.TANDCSECOND}
                                      </div>
                                    )}
                                </div>
                              )}

                              {TandCThird && (
                                <div className="terms-form-wrap">
                                  {TandCThirdOption.term !== false && (
                                    <div className="form-check">
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="TANDCTHIRD"
                                        name="TANDCTHIRD"
                                        onChange={(e) =>
                                          formik.setFieldValue(
                                            "TANDCTHIRD",
                                            e.target.checked ? "on" : ""
                                          )
                                        }
                                        onBlur={formik.handleBlur}
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor="TANDCTHIRD"
                                        dangerouslySetInnerHTML={asHTML(
                                          TandCThird
                                        )}
                                      />
                                    </div>
                                  )}
                                  {formik.touched.TANDCTHIRD &&
                                    formik.errors.TANDCTHIRD && (
                                      <div className="error">
                                        {formik.errors.TANDCTHIRD}
                                      </div>
                                    )}
                                </div>
                              )}

                              <div
                                className="btn-wrapper d-flex"
                                style={{ justifyContent: submitPosition }}
                              >
                                {subLoading ? (
                                  <button
                                    className="btn btn-primary btn-icon"
                                    type="submit"
                                    disabled
                                  >
                                    Loading...
                                    <div
                                      className="spinner-border text-light"
                                      role="status"
                                    >
                                      <span className="visually-hidden">
                                        Loading...
                                      </span>
                                    </div>
                                  </button>
                                ) : (
                                  <button
                                    className="btn btn-primary btn-icon"
                                    type="submit"
                                  >
                                    {submitTitle}
                                    <Svg name="button-icon" />
                                  </button>
                                )}
                              </div>
                            </form>
                          )}

                          {flagFormStep === 2 && (
                            <div className="text-inner">
                              <div className="heading-wrapper">
                                <h1>Verify email</h1>
                                <p>
                                  We've sent a 6-digit verification code to your
                                  email.
                                </p>
                              </div>
                              <div className="form-wrapper">
                                <div className="form-floating mb-4">
                                  <input
                                    className="form-control"
                                    id="otp"
                                    name="otp"
                                    type="text"
                                    placeholder="Enter otp"
                                    value={otp}
                                    onInput={(e) => {
                                      setOtp(e.target.value);
                                      setotpError(false);
                                    }}
                                    maxLength={6}
                                    inputMode="numeric"
                                    onKeyPress={(e) => {
                                      if (!/^[0-9\b]+$/.test(e.key))
                                        e.preventDefault();
                                    }}
                                  />
                                  <label htmlFor="otp">OTP</label>
                                  {otpError && (
                                    <div className="error">{checkotp}</div>
                                  )}
                                </div>
                                <div
                                  className="btn-wrapper d-flex"
                                  style={{ justifyContent: submitPosition }}
                                >
                                  {/* <button className="btn btn-primary btn-icon" type="button" onClick={otpVerify}>
            Verify <Svg name="button-icon" />
          </button> */}
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="desclaimer-text">
                        <p>
                          Your personal data will be processed in accordance
                          with&nbsp;aiLandingCompanyName
                          <a
                            href="https://www.tatacommunications.com/policies/privacy/"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            privacy policy
                          </a>{" "}
                          . By clicking submit you confirm that you have read
                          and understood the privacy policy.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    );
}




